'use strict';

import $ from 'jquery';
import config from '../../js/config';

export default class SimpleAccordion {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.initialize();
  }

  initialize() {
    this.$el.on('click', '.SimpleAccordion-toggle', this.toggleAccordionItem.bind(this));
  }

  toggleAccordionItem(e) {
    $(e.currentTarget).toggleClass(config.classes.isOpen);
  }
}

export function createSimpleAccordion($parent) {
  $parent.find('.SimpleAccordion').each((n, el) => new SimpleAccordion(el));
}



// WEBPACK FOOTER //
// ./assets/components/SimpleAccordion/SimpleAccordion.js